/**
 * User and membership utilities for the settings modal
 * Handles user data fetching and outfit availability checks
 */
import { isOutfitAllowedForContext, loadOutfitExceptionKeys } from '../../shared/outfit-exception-utils.js';

// Get user data including membership tier
export async function getUserData() {
    try {
        const { storageManager } = await import('../../../../core/storage/index.js');
        const userData = await storageManager.getItem('userData');
        return {
            userId: userData?.id || userData?.user_id,
            isLoggedIn: !!(userData?.id || userData?.user_id),
            membershipTier: userData?.current_tier || 'free'
        };
    } catch (error) {
        console.error('Error getting user data:', error);
        return { userId: null, isLoggedIn: false, membershipTier: 'free' };
    }
}

// Check if user has a paid membership (any tier other than free)
export function hasPaidMembership(membershipTier) {
    return membershipTier && membershipTier !== 'free';
}

export { loadOutfitExceptionKeys };

// Check if an outfit is available based on membership tier and tuple exceptions
export function isOutfitAvailable(outfit, membershipTier, options = {}) {
    const { scenarioId = null, characterId = null, exceptionKeys = null } = options;
    const outfitId = parseInt(outfit.id, 10);
    const normalizedOutfitId = Number.isNaN(outfitId) ? outfit.id : outfitId;

    return isOutfitAllowedForContext({
        hasPaidMembership: hasPaidMembership(membershipTier),
        scenarioId,
        characterId,
        outfitId: normalizedOutfitId,
        exceptionKeys
    });
}
